// import BASE_API from '@/api/dataBase';
// import COMPANY_API from '@/api/dataBase';

export const searchColumns = (_this) => {
  return [
    // {
    //   prop: 'platformCompanyNo',
    //   name: '平台公司',
    //   type: 'ajaxSelect',
    //   apiUrl: COMPANY_API.GET_PERSON_API,
    //   apiData: {
    //     id: _this.userInfo.userCode,
    //     userCode: _this.userInfo.userCode,
    //     personName: _this.userInfo.userName,
    //   },
    //   dataString: 'data.personCompanyInfo',
    //   clearable: true,
    //   filterable: true,
    //   valueKey: 'personCompanyCode',
    //   labelKey: 'personCompanyName',
    //   changeMethod: 'changeMethod',
    //   method: 'post',
    // },
    {
      prop: 'platformCompanyNo',
      name: '平台公司',
      type: 'select',
      options: _this.companyList,
      value: 'personCompanyCode',
      label: 'personCompanyName',
      changeMethod: 'changeMethod',
    },
    {
      prop: 'createDepartmentNo',
      name: '创建组织',
      type: 'select',
      options: _this.departmentList,
      filterable: true,
      label: 'personDepartmentName',
      value: 'personDepartmentCode',
    },
    // {
    //   prop: 'saleDepartmentNo',
    //   name: '销售组织',
    //   type: 'treeSelect',
    //   apiUrl: BASE_API.LIST_COMPANY_DEPT_TREE,
    //   // multiple: true,
    //   isName: true, // 是否返回名字
    //   returnType: 'object', // 全部返回当前对象
    //   changeMethod: 'handleChange',
    //   ref: 'saleDepartmentName',
    //   // currentValue: '7024', // 默认选中的
    //   apiData: {
    //     tenantCode: _this.userInfo.tenantCode,
    //     adminFlag: _this.userInfo.adminFlag,
    //     // selfCompanyDepartmentTreeFlag: true,
    //   },
    // },
    {
      name: '订单编号',
      prop: 'orderCode',
      type: 'input',
    },
    {
      name: '物料号',
      prop: 'materialNo',
      type: 'input',
    },
    {
      prop: 'customerName',
      name: '客户名称',
      type: 'input',
    },

    // {
    //   prop: 'contractCode',
    //   name: '客户合同',
    //   type: 'select',
    //   options: _this.contractList,
    // },
    {
      name: '客户合同',
      prop: 'contractCode',
      type: 'searchTableSpec',
      searchType: 'multransportContract',
      extraData: {
        platformCompanyName: _this.userInfo.companyName,
        contractType: '0',
        isCS: 'C',
        contractStatus: 'ZT03',
      },
      isMultiple: true,
    },
    {
      prop: 'orderStatus',
      name: '订单状态',
      type: 'select',
      options: orderStatusList,
    },
    {
      prop: 'serviceType',
      name: '服务类型',
      type: 'dict',
      dictType: 'INTERMODALITY-SERVICE-TYPE',
      // changeMethod: 'serviceTypeChange',
    },
    {
      name: '订单创建时间起',
      prop: 'orderCreateStartDate',
      type: 'startDaterangePicker',
    },
    {
      name: '订单创建时间至',
      prop: 'orderCreateEndDate',
      type: 'endDaterangePicker',
    },
    {
      name: '订单完成时间起',
      prop: 'orderCompletedStartDate',
      type: 'startDaterangePicker',
    },
    {
      name: '订单完成时间至',
      prop: 'orderCompletedEndDate',
      type: 'endDaterangePicker',
    },
  ];
};

export const orderStatusList = [
  { label: '草稿', value: 'draft' },
  { label: '部分下发', value: 'part_issued' },
  { label: '已下发', value: 'issued' },
  { label: '进行中', value: 'ongoing' },
  { label: '业务已完成', value: 'completed' },
  // { label: '已开票', value: 'invoiced' },
  // { label: '部分付款', value: 'part_paid' },
  // { label: '已付款', value: 'paid' },
  // { label: '部分收款', value: 'part_received' },
  // { label: '已收款', value: 'received' },
  // { label: '已关闭', value: 'closed' },
  { label: '已作废', value: 'invalid' },
  // { label: '已超期', value: 'expired' },
];

export const columns = [
  // {
  //   type: 'checkbox',
  //   visible: true,
  //   width: '50',
  //   fixed: 'left',
  // },
  // {
  //   type: 'seq',
  //   title: 'table.index',
  //   visible: true,
  //   width: '80',
  // },
  {
    field: 'orderCreateDate',
    title: '订单创建时间',
    visible: true,
  },
  {
    field: 'orderCode',
    title: '订单编号',
    visible: true,
  },
  {
    field: 'orderStatusName',
    title: '订单状态',
    visible: true,
  },
  {
    field: 'customerName',
    title: '客户名称',
    visible: true,
  },
  {
    field: 'contractName',
    title: '客户合同',
    visible: true,
  },
  {
    field: 'projectName',
    title: '项目名称',
    visible: true,
  },
  {
    field: 'productTypeName',
    title: '产品类型',
    visible: true,
  },
  {
    field: 'materialNo',
    title: '物料号',
    visible: true,
  },
  {
    field: 'serviceTypeName',
    title: '服务类型',
    visible: true,
  },
  {
    field: 'orderCompletedDate',
    title: '订单完成时间',
    visible: true,
  },
  {
    field: 'platformCompanyName',
    title: '平台公司',
    visible: true,
  },
  {
    field: 'createDepartmentName',
    title: '创建组织',
    visible: true,
  },
  // {
  //   field: 'saleDepartmentName',
  //   title: '销售组织',
  //   visible: true,
  // },
  {
    field: 'operate',
    title: '操作',
    visible: true,
    fixed: 'right',
  },
];

export const headerBtns = [
  {
    name: '保存',
    type: 'primary',
    changeMethod: 'save',
  },
  {
    name: '一键下发',
    type: 'primary',
    changeMethod: 'oneClickRelease',
  },
  {
    name: '一键下发并新增',
    type: 'primary',
    changeMethod: 'oneClickReleaseAndRefresh',
  },
  // {
  //   name: '取消',
  //   type: 'info',
  //   changeMethod: 'cancel',
  // },
];

export const detailHeaderBtns = [
  // {
  //   name: '查看结算状态',
  //   type: 'primary',
  //   changeMethod: 'settleStatus',
  // },
  {
    name: '保存',
    type: 'primary',
    changeMethod: 'save',
  },
  {
    name: '一键下发',
    type: 'primary',
    changeMethod: 'oneClickRelease',
  },
  {
    name: '作废',
    type: 'primary',
    changeMethod: 'invalid',
  },
  // {
  //   name: '取消',
  //   type: 'info',
  //   changeMethod: 'cancel',
  // },
];

export const transportColumn = (ctx) => {
  return [
    // {
    //   type: 'checkbox',
    //   visible: true,
    //   width: '50',
    //   fixed: 'left',
    // },
    // {
    //   type: 'seq',
    //   width: '60',
    // },
    ...(ctx.turnType === '3'
      ? [
          {
            field: 'instructCode',
            title: '运输指令单编号',
            visible: true,
            width: 200,
          },
        ]
      : []),
    // {
    //   field: 'purchaseOrgName',
    //   title: '采购组织',
    //   visible: true,
    //   width: '150',
    // },
    {
      field: 'serviceProviderName',
      title: '服务供方',
      visible: true,
      width: '150',
    },
    ...(ctx.turnType === '3'
      ? [
          {
            field: 'instructStatus',
            title: '运输服务指令状态',
            visible: true,
            width: 200,
          },
          {
            field: 'instructIssueDate',
            title: '服务下发时间',
            visible: true,
            width: 200,
          },
          {
            field: 'instructUpdateDate',
            title: '最近更新时间',
            visible: true,
            width: 200,
          },
        ]
      : ctx.turnType === '1'
      ? [
          {
            field: 'instructStatus',
            title: '运输服务指令状态',
            visible: true,
            width: 200,
          },
        ]
      : []),
    {
      field: 'isOverdue',
      title: '是否超期',
      visible: true,
      width: '150',
    },
    {
      field: 'routeName',
      title: '线路名',
      visible: true,
      width: '150',
    },
    {
      field: 'departurePlaceName',
      title: '启运地',
      visible: true,
      width: '150',
    },
    {
      field: 'destinationName',
      title: '目的地',
      visible: true,
      width: '150',
    },
    {
      field: 'materialNo',
      title: '物料号',
      visible: true,
      width: '150',
    },
    {
      field: 'productParentName',
      title: '商品名称',
      visible: true,
      width: '150',
    },
    {
      field: 'productDetailCode',
      title: '商品子类编码',
      visible: true,
      width: '150',
    },
    {
      field: 'detailProductItems',
      title: '品目',
      visible: true,
      width: '150',
    },
    {
      field: 'detailProductModel',
      title: '规格',
      visible: true,
      width: '150',
    },
    {
      field: 'qty',
      title: '件数',
      visible: true,
      width: '150',
    },
    {
      field: 'qtyUnit',
      title: '件数单位',
      visible: true,
      width: '150',
    },
    {
      field: 'roughWeight',
      title: '结算重量',
      visible: true,
      width: '150',
    },
    {
      field: 'roughWeightUnit',
      title: '结算单位',
      visible: true,
      width: '150',
    },
    {
      field: 'netWeight',
      title: '净重',
      visible: true,
      width: '150',
    },
    {
      field: 'netWeightUnit',
      title: '净重单位',
      visible: true,
      width: '150',
    },
    {
      field: 'volume',
      title: '体积',
      width: '150',
      visible: true,
    },
    {
      field: 'volumeUnit',
      title: '体积单位',
      width: '150',
      visible: true,
    },
    {
      field: 'transportMode',
      title: '运输服务方式',
      visible: true,
      width: '150',
    },
    {
      field: 'contactConsignor',
      title: '发货联系人',
      visible: true,
      width: '150',
    },
    {
      field: 'contactConsignorPhone',
      title: '发货人联系方式',
      visible: true,
      width: '150',
    },
    {
      field: 'planPickupDate',
      title: '计划提货日期',
      visible: true,
      width: '150',
    },
    {
      field: 'pickupRequire',
      title: '提货要求',
      visible: true,
      width: '150',
    },
    {
      field: 'contactConsignee',
      title: '收货联系人',
      visible: true,
      width: '150',
    },
    {
      field: 'contactConsigneePhone',
      title: '收货人联系方式',
      visible: true,
      width: '150',
    },
    {
      field: 'planDeliveryDate',
      title: '计划发货日期',
      visible: true,
      width: '150',
    },
    {
      field: 'deliveryRequire',
      title: '送货要求',
      visible: true,
      width: '150',
    },
    {
      field: 'planReceiptDate',
      title: '计划回单日期',
      visible: true,
      width: '150',
    },
    {
      field: 'planArrivalDate',
      title: '计划到货日期',
      visible: true,
      width: '150',
    },
    {
      field: 'customerRequireModel',
      title: '客户要求车型',
      visible: true,
      width: '150',
    },
    {
      field: 'customerRequireSize',
      title: '客户要求吨位尺寸',
      visible: true,
      width: '150',
    },
    {
      field: 'customerRequireQty',
      title: '车型要求数量',
      visible: true,
      width: '150',
    },
    { field: 'receiveUnit', title: '收货单位', visible: true, width: '150' },
    {
      field: 'remarks',
      title: '备注',
      visible: true,
      width: '150',
    },
  ];
};

export const baseFormRules = {
  serviceProviderCode: [{ required: true, message: '服务供方必选', trigger: 'change' }],
  routeCode: [{ required: true, message: '线路名必选', trigger: 'change' }],
  contactConsignor: [{ required: true, message: '发货联系人必填', trigger: 'change' }],
  contactConsignorPhone: [{ required: true, message: '发货人联系方式必填', trigger: 'change' }],
  planPickupDate: [{ required: true, message: '计划提货日期必选', trigger: 'change' }],
  contactConsignee: [{ required: true, message: '收货联系人必填', trigger: 'change' }],
  contactConsigneePhone: [{ required: true, message: '收货人联系方式必填', trigger: 'change' }],
  planDeliveryDate: [{ required: true, message: '计划发货日期必选', trigger: 'change' }],
  productParentName: [{ required: true, message: '商品名称必选', trigger: 'change' }],
  roughWeight: [{ required: true, message: '结算重量必选', trigger: 'change' }],
  roughWeightUnit: [{ required: true, message: '结算单位必选', trigger: 'change' }],
  netWeight: [{ required: true, message: '净重必选', trigger: 'change' }],
  netWeightUnit: [{ required: true, message: '净重单位必选', trigger: 'change' }],
  transportMode: [{ required: true, message: '运输服务方式必选', trigger: 'change' }],
  departurePlaceName: [{ required: true, message: '启运地必填', trigger: 'change' }],
  destinationName: [{ required: true, message: '目的地必填', trigger: 'change' }],
};

export const baseColumnList = (ctx) => {
  return [
    // {
    //   name: '序号',
    //   prop: 'sortNo',
    //   type: 'input',
    //   disabled: true,
    // },
    {
      name: '服务供方',
      prop: 'serviceProviderCode',
      type: 'select',
      options: ctx.serviceProviderList || [],
      label: 'supplierName',
      value: 'supplierCode',
      changeMethod: ctx.changeServiceProviderHandler,
      disabled: ctx.formItemDisable,
    },
    // {
    //   name: '采购组织',
    //   prop: 'purchaseOrgCode',
    //   type: 'select',
    //   options: ctx.routeNameList || [],
    //   label: 'name',
    //   value: 'code',
    //   changeMethod: ctx.changeRouteHandler,
    // },
    {
      name: '线路名',
      prop: 'routeCode',
      type: 'select',
      options: ctx.contractRoutes || [],
      label: 'name',
      value: 'code',
      changeMethod: ctx.changeRouteHandler,
      disabled: ctx.formItemDisable,
    },
    {
      name: '启始地',
      prop: 'departurePlaceName',
      type: 'input',
      // disabled: true,
      disabled: ctx.otherFormItem,
    },
    {
      name: '目的地',
      prop: 'destinationName',
      type: 'input',
      disabled: ctx.otherFormItem,
      // disabled: true,
    },
    {
      name: '备注',
      prop: 'remarks',
      type: 'input',
      maxlength: 500,
      disabled: ctx.otherFormItem,
    },
    {
      name: '发货联系人',
      prop: 'contactConsignor',
      type: 'input',
      disabled: ctx.formItemDisable,
    },
    {
      name: '发货人联系方式',
      prop: 'contactConsignorPhone',
      type: 'inputNumber',
      maxlength: 11,
      disabled: ctx.formItemDisable,
    },
    {
      name: '计划提货日期',
      prop: 'planPickupDate',
      type: 'date',
      // endDate: true,
      disabled: ctx.formItemDisable,
    },
    {
      name: '提货要求',
      prop: 'pickupRequire',
      type: 'input',
      disabled: ctx.formItemDisable,
    },
    {
      name: '收货联系人',
      prop: 'contactConsignee',
      type: 'input',
      disabled: ctx.otherFormItem,
    },
    {
      name: '收货人联系方式',
      prop: 'contactConsigneePhone',
      type: 'inputNumber',
      maxlength: 11,
      disabled: ctx.otherFormItem,
    },
    {
      name: '计划发货日期',
      prop: 'planDeliveryDate',
      type: 'date',
      // endDate: true,
      disabled: ctx.formItemDisable,
    },
    {
      name: '计划回单日期',
      prop: 'planReceiptDate',
      type: 'date',
      // endDate: true,
      disabled: ctx.formItemDisable,
    },
    {
      name: '送货要求',
      prop: 'deliveryRequire',
      type: 'input',
      disabled: ctx.formItemDisable,
    },
    {
      name: '客户要求车型',
      prop: 'customerRequireModel',
      type: 'select',
      options: ctx.carList || [],
      disabled: ctx.formItemDisable,
    },
    {
      name: '客户要求吨位尺寸',
      prop: 'customerRequireSize',
      type: 'select',
      options: ctx.weightList || [],
      disabled: ctx.formItemDisable,
    },
    {
      name: '车型要求数量',
      prop: 'customerRequireQty',
      type: 'inputNumber',
      disabled: ctx.formItemDisable,
    },
    {
      name: '物料号',
      prop: 'materialNo',
      type: 'input',
      disabled: ctx.formItemDisable,
    },
    // {
    //   name: '商品名称',
    //   prop: 'productParentName',
    //   label: 'productChName',
    //   value: 'productChName',
    //   type: 'select',
    //   options: ctx.goodsList,
    //   changeMethod: ctx.changeProductHandler,
    //   disabled: ctx.formItemDisable,
    // },
    {
      name: '商品名称',
      prop: 'productParentName',
      type: 'select',
      options: ctx.productParentList,
      filterable: true,
      disabled: ctx.formItemDisable,
      changeMethod: ctx.changeProductHandler,
    },
    {
      name: '商品子类编码',
      prop: 'productDetailCode',
      type: 'select',
      options: ctx.productChildList,
      filterable: true,
      changeMethod: ctx.changeSearchCodeHandler,
      disabled: !ctx.generalServiceForm.productParentNo || ctx.formItemDisable,
    },
    // {
    //   name: '商品子类编码',
    //   prop: 'productDetailCode',
    //   label: 'productDetailCode',
    //   value: 'id',
    //   type: 'select',
    //   options: ctx.detailCodeList,
    //   changeMethod: ctx.changeSearchCodeHandler,
    //   disabled: ctx.formItemDisable,
    // },
    {
      name: '品目',
      prop: 'detailProductItems',
      type: 'input',
      disabled: true,
    },
    {
      name: '规格',
      prop: 'detailProductModel',
      type: 'input',
      disabled: true,
    },
    {
      name: '件数',
      prop: 'qty',
      type: 'inputNumber',
      disabled: ctx.formItemDisable,
    },
    {
      name: '件数单位',
      prop: 'qtyUnit',
      type: 'select',
      options: ctx.numberUnitList || [],
      disabled: ctx.formItemDisable,
    },
    {
      name: '结算重量',
      prop: 'roughWeight',
      type: 'inputNumber',
      disabled: ctx.formItemDisable,
      precision: 4,
    },
    {
      name: '结算单位',
      prop: 'roughWeightUnit',
      type: 'select',
      options: ctx.weightUnitList || [],
      disabled: ctx.formItemDisable,
    },
    {
      name: '净重',
      prop: 'netWeight',
      type: 'inputNumber',
      precision: 4,
      disabled: ctx.formItemDisable,
    },
    {
      name: '净重单位',
      prop: 'netWeightUnit',
      type: 'select',
      options: ctx.weightUnitList || [],
      disabled: ctx.formItemDisable,
    },
    {
      name: '体积',
      prop: 'volume',
      type: 'inputNumber',
      disabled: ctx.formItemDisable,
    },
    {
      name: '体积单位',
      prop: 'volumeUnit',
      type: 'select',
      options: ctx.volumeUnitList || [],
      disabled: ctx.formItemDisable,
    },
    {
      name: '运输服务方式',
      prop: 'transportMode',
      type: 'select',
      options: ctx.serviceMethodsList || [],
      disabled: ctx.formItemDisable,
    },
    {
      name: '计划到货日期',
      prop: 'planArrivalDate',
      type: 'date',
      disabled: ctx.formItemDisable,
    },
    {
      name: '收货单位',
      prop: 'receiveUnit',
      type: 'input',
      disabled: ctx.formItemDisable,
    },
    {
      name: '物料描述',
      prop: 'goodsDesc',
      type: 'textarea',
      disabled: ctx.formItemDisable,
      span: 24,
    },
  ];
};

// 集卡运输表头
export const truckColumn = (ctx) => {
  return [
    // {
    //   type: 'checkbox',
    //   visible: true,
    //   width: '50',
    //   fixed: 'left',
    // },
    // {
    //   type: 'index',
    //   visible: true,
    //   width: '60',
    //   fixed: 'left',
    //   title: '序号',
    // },
    ...(ctx.turnType === '3'
      ? [
          {
            field: 'instructCode',
            title: '运输指令单编号',
            visible: true,
            width: '150',
          },
        ]
      : []),
    // {
    //   field: 'purchaseOrgName',
    //   title: '采购组织',
    //   visible: true,
    //   width: '150',
    // },
    {
      field: 'serviceProviderName',
      title: '服务供方',
      visible: true,
      width: '150',
      // editRender: {
      //   name: 'serviceProviderName',
      // },
    },
    ...(ctx.turnType === '3'
      ? [
          {
            field: 'instructStatus',
            title: '运输服务指令状态',
            visible: true,
            width: '150',
          },
          {
            field: 'instructIssueDate',
            title: '服务下发时间',
            visible: true,
            width: '150',
          },
          {
            field: 'instructUpdateDate',
            title: '最近更新时间',
            visible: true,
            width: '150',
          },
        ]
      : ctx.turnType === '1'
      ? [
          {
            field: 'instructStatus',
            title: '运输服务指令状态',
            visible: true,
            width: '150',
          },
        ]
      : []),
    {
      field: 'isOverdue',
      title: '是否超期',
      visible: true,
      width: '150',
    },
    {
      field: 'routeName',
      title: '线路名',
      visible: true,
      width: '150',
    },
    {
      field: 'departurePlaceName',
      title: '启运地',
      visible: true,
      width: '150',
    },
    {
      field: 'destinationName',
      title: '目的地',
      visible: true,
      width: '150',
    },
    {
      field: 'productParentName',
      title: '商品名称',
      visible: true,
      width: '150',
    },
    {
      field: 'productDetailCode',
      title: '商品子类编码',
      visible: true,
      width: '150',
    },
    {
      field: 'detailProductItems',
      title: '品目',
      visible: true,
      width: '150',
    },
    {
      field: 'detailProductModel',
      title: '规格',
      visible: true,
      width: '150',
    },
    {
      field: 'qty',
      title: '件数',
      visible: true,
      width: '150',
    },
    {
      field: 'qtyUnit',
      title: '件数单位',
      visible: true,
      width: '150',
    },
    {
      field: 'roughWeight',
      title: '结算重量',
      visible: true,
      width: '150',
    },
    {
      field: 'roughWeightUnit',
      title: '结算单位',
      visible: true,
      width: '150',
    },
    {
      field: 'netWeight',
      title: '净重',
      visible: true,
      width: '150',
    },
    {
      field: 'netWeightUnit',
      title: '净重单位',
      visible: true,
      width: '150',
    },
    {
      field: 'volume',
      title: '体积',
      width: '150',
      visible: true,
    },
    {
      field: 'volumeUnit',
      title: '体积单位',
      width: '150',
      visible: true,
    },
    {
      field: 'containerType',
      title: '箱型',
      width: '150',
      visible: true,
    },
    {
      field: 'putContainerLadeNo',
      title: '放箱提单号',
      width: '150',
      visible: true,
    },
    {
      field: 'planPickupContainerDate',
      title: '预提箱日期',
      width: '150',
      visible: true,
    },
    {
      field: 'transportMode',
      title: '运输服务方式',
      visible: true,
      width: '150',
    },
    {
      field: 'contactConsignor',
      title: '发货联系人',
      visible: true,
      width: '150',
    },
    {
      field: 'contactConsignorPhone',
      title: '发货人联系方式',
      visible: true,
      width: '150',
    },
    {
      field: 'planPickupDate',
      title: '计划提货日期',
      visible: true,
      width: '150',
    },
    {
      field: 'pickupRequire',
      title: '提货要求',
      visible: true,
      width: '150',
    },
    {
      field: 'contactConsignee',
      title: '收货联系人',
      visible: true,
      width: '150',
    },
    {
      field: 'contactConsigneePhone',
      title: '收货人联系方式',
      visible: true,
      width: '150',
    },
    {
      field: 'planDeliveryDate',
      title: '计划发货日期',
      visible: true,
      width: '150',
    },
    {
      field: 'deliveryRequire',
      title: '送货要求',
      visible: true,
      width: '150',
    },
    {
      field: 'planReceiptDate',
      title: '计划回单日期',
      visible: true,
      width: '150',
    },
    {
      field: 'planArrivalDate',
      title: '计划到货日期',
      visible: true,
      width: '150',
    },
    {
      field: 'customerRequireModel',
      title: '客户要求车型',
      visible: true,
      width: '150',
    },
    {
      field: 'customerRequireSize',
      title: '客户要求吨位尺寸',
      visible: true,
      width: '150',
    },
    {
      field: 'customerRequireQty',
      title: '车型要求数量',
      visible: true,
      width: '150',
    },
    {
      field: 'remarks',
      title: '备注',
      visible: true,
      width: '150',
    },
  ];
};

// 集卡运输新增form表格
export const truckColumnList = (ctx) => {
  return [
    {
      name: '服务供方',
      prop: 'serviceProviderCode',
      type: 'select',
      options: ctx.serviceProviderList || [],
      label: 'supplierName',
      value: 'supplierCode',
      changeMethod: ctx.changeServiceProviderHandler,
      disabled: ctx.formItemDisable,
    },
    {
      name: '箱型',
      prop: 'containerType',
      type: 'select',
      options: ctx.typeListOne || [],
      disabled: ctx.formItemDisable,
    },
    {
      name: '放箱提单号',
      prop: 'putContainerLadeNo',
      type: 'input',
      disabled: ctx.formItemDisable,
    },
    {
      name: '预提箱日期',
      prop: 'planPickupContainerDate',
      type: 'date',
      endDate: true,
      disabled: ctx.formItemDisable,
    },
    {
      name: '线路名',
      prop: 'routeCode',
      type: 'select',
      options: ctx.contractRoutes || [],
      label: 'name',
      value: 'code',
      changeMethod: ctx.changeRouteHandler,
      disabled: ctx.formItemDisable,
    },
    {
      name: '启始地',
      prop: 'departurePlaceName',
      type: 'input',
      disabled: ctx.otherFormItem,
    },
    {
      name: '目的地',
      prop: 'destinationName',
      type: 'input',
      disabled: ctx.otherFormItem,
    },
    {
      name: '备注',
      prop: 'remarks',
      type: 'input',
      maxlength: 500,
      disabled: ctx.formItemDisable,
    },
    {
      name: '发货联系人',
      prop: 'contactConsignor',
      type: 'input',
      disabled: ctx.formItemDisable,
    },
    {
      name: '发货人联系方式',
      prop: 'contactConsignorPhone',
      type: 'inputNumber',
      maxlength: 11,
      disabled: ctx.formItemDisable,
    },
    {
      name: '计划提货日期',
      prop: 'planPickupDate',
      type: 'date',
      endDate: true,
      disabled: ctx.formItemDisable,
    },
    {
      name: '计划回单日期',
      prop: 'planReceiptDate',
      endDate: true,
      type: 'date',
      disabled: ctx.formItemDisable,
    },
    {
      name: '提货要求',
      prop: 'pickupRequire',
      type: 'input',
      disabled: ctx.formItemDisable,
    },
    {
      name: '收货联系人',
      prop: 'contactConsignee',
      type: 'input',
      disabled: ctx.formItemDisable,
    },
    {
      name: '收货人联系方式',
      prop: 'contactConsigneePhone',
      type: 'inputNumber',
      maxlength: 11,
      disabled: ctx.formItemDisable,
    },
    {
      name: '计划发货日期',
      prop: 'planDeliveryDate',
      endDate: true,
      type: 'date',
      disabled: ctx.formItemDisable,
    },
    {
      name: '送货要求',
      prop: 'deliveryRequire',
      type: 'input',
      disabled: ctx.formItemDisable,
    },
    {
      name: '客户要求车型',
      prop: 'customerRequireModel',
      type: 'select',
      options: ctx.carList || [],
      disabled: ctx.formItemDisable,
    },
    {
      name: '客户要求吨位尺寸',
      prop: 'customerRequireSize',
      type: 'select',
      disabled: ctx.formItemDisable,
      options: ctx.weightList || [],
    },
    {
      name: '车型要求数量',
      prop: 'customerRequireQty',
      disabled: ctx.formItemDisable,
      type: 'inputNumber',
    },
    {
      name: '商品名称',
      prop: 'productParentName',
      type: 'select',
      options: ctx.productParentList,
      filterable: true,
      // type: 'searchTableSpec',
      // searchType: 'goodsIntermodalityContractParent',
      // isMultiple: true,
      // extraData: {
      //   parentProductStatus: 'ZT03',
      //   adminFlag: ctx.userInfo.adminFlag,
      //   selectCompanyCode: ctx.userInfo.companyCode,
      //   contractCode: ctx.contractCode,
      // },
      // currentValue: ctx.generalServiceForm.productParentName,
      // checkRowKeys: [ctx.generalServiceForm.productParentNo],
      disabled: ctx.formItemDisable,
      changeMethod: ctx.changeProductHandler,
    },
    {
      name: '商品子类编码',
      prop: 'productDetailCode',
      type: 'select',
      options: ctx.productChildList,
      filterable: true,
      disabled: !ctx.generalServiceForm.productParentNo || ctx.formItemDisable,
      changeMethod: ctx.changeSearchCodeHandler,
    },
    // {
    //   name: '商品名称',
    //   prop: 'productParentName',
    //   type: 'searchTableSpec',
    //   searchType: 'product',
    //   isMultiple: true,
    //   extraData: {
    //     parentProductStatus: 'ZT03',
    //     adminFlag: ctx.userInfo.adminFlag,
    //     selectCompanyCode: ctx.userInfo.companyCode,
    //   },
    //   currentValue: ctx.generalServiceForm.productParentName,
    //   checkRowKeys: [ctx.generalServiceForm.productParentNo],
    //   disabled: ctx.formItemDisable,
    //   changeMethod: ctx.changeProductHandler,
    // },
    // {
    //   name: '商品子类编码',
    //   prop: 'productDetailCode',
    //   type: 'searchTableSpec',
    //   searchType: 'goodsAllCategory',
    //   isMultiple: true,
    //   currentValue: ctx.generalServiceForm.productDetailCode,
    //   checkRowKeys: [ctx.generalServiceForm.productDetailCode],
    //   extraData: {
    //     adminFlag: ctx.userInfo.adminFlag,
    //     productChName: ctx.generalServiceForm.productParentName,
    //     productParentCode: ctx.generalServiceForm.productParentNo,
    //   },
    //   disabled: !ctx.generalServiceForm.productParentNo || ctx.formItemDisable,
    //   changeMethod: ctx.changeSearchCodeHandler,
    // },
    // {
    //   name: '商品名称',
    //   prop: 'productParentName',
    //   label: 'productChName',
    //   value: 'productChName',
    //   type: 'select',
    //   options: ctx.goodsList,
    //   changeMethod: ctx.changeProductHandler,
    //   disabled: ctx.formItemDisable,
    // },
    // {
    //   name: '商品子类编码',
    //   prop: 'productDetailCode',
    //   label: 'productDetailCode',
    //   value: 'id',
    //   type: 'select',
    //   options: ctx.detailCodeList,
    //   changeMethod: ctx.changeSearchCodeHandler,
    //   disabled: ctx.formItemDisable,
    // },
    {
      name: '品目',
      prop: 'detailProductItems',
      type: 'input',
      disabled: true,
    },
    {
      name: '规格',
      prop: 'detailProductModel',
      type: 'input',
      disabled: true,
    },
    {
      name: '件数',
      prop: 'qty',
      type: 'inputNumber',
      disabled: ctx.formItemDisable,
    },
    {
      name: '件数单位',
      prop: 'qtyUnit',
      type: 'select',
      disabled: ctx.formItemDisable,
      options: ctx.numberUnitList || [],
    },
    {
      name: '结算重量',
      prop: 'roughWeight',
      disabled: ctx.formItemDisable,
      type: 'inputNumber',
      precision: 4,
    },
    {
      name: '结算单位',
      prop: 'roughWeightUnit',
      type: 'select',
      options: ctx.weightUnitList || [],
      disabled: ctx.formItemDisable,
    },
    {
      name: '净重',
      prop: 'netWeight',
      type: 'inputNumber',
      disabled: ctx.formItemDisable,
      precision: 4,
    },
    {
      name: '净重单位',
      prop: 'netWeightUnit',
      type: 'select',
      options: ctx.weightUnitList || [],
      disabled: ctx.formItemDisable,
    },
    {
      name: '体积',
      prop: 'volume',
      type: 'inputNumber',
      disabled: ctx.formItemDisable,
    },
    {
      name: '体积单位',
      prop: 'volumeUnit',
      type: 'select',
      options: ctx.volumeUnitList || [],
      disabled: ctx.formItemDisable,
    },
    {
      name: '运输服务方式',
      prop: 'transportMode',
      type: 'select',
      options: ctx.serviceMethodsList || [],
      disabled: ctx.formItemDisable,
    },
    {
      name: '计划到货日期',
      prop: 'planArrivalDate',
      type: 'date',
      disabled: ctx.formItemDisable,
    },
  ];
};

// 集卡验证规则
export const truckFormRules = {
  serviceProviderCode: [{ required: true, message: '服务供方必选', trigger: 'change' }],
  containerType: [{ required: true, message: '箱型必选', trigger: 'change' }],
  routeCode: [{ required: true, message: '线路名必选', trigger: 'change' }],
  contactConsignor: [{ required: true, message: '发货联系人必填', trigger: 'change' }],
  contactConsignorPhone: [{ required: true, message: '发货人联系方式必填', trigger: 'change' }],
  planPickupDate: [{ required: true, message: '计划提货日期必选', trigger: 'change' }],
  contactConsignee: [{ required: true, message: '收货联系人必填', trigger: 'change' }],
  contactConsigneePhone: [{ required: true, message: '收货人联系方式必填', trigger: 'change' }],
  planDeliveryDate: [{ required: true, message: '计划发货日期必选', trigger: 'change' }],
  productParentName: [{ required: true, message: '商品名称必选', trigger: 'change' }],
  roughWeight: [{ required: true, message: '结算重量必选', trigger: 'change' }],
  roughWeightUnit: [{ required: true, message: '结算单位必选', trigger: 'change' }],
  netWeight: [{ required: true, message: '净重必选', trigger: 'change' }],
  netWeightUnit: [{ required: true, message: '净重单位必选', trigger: 'change' }],
  transportMode: [{ required: true, message: '运输服务方式必选', trigger: 'change' }],
  departurePlaceName: [{ required: true, message: '启运地必填', trigger: 'change' }],
  destinationName: [{ required: true, message: '目的地必填', trigger: 'change' }],
};

// 铁路运输代理服务表格
export const agencyFormColumn = (ctx) => {
  return [
    // {
    //   name: '采购组织',
    //   prop: 'purchaseOrgName',
    //   type: 'input',
    //   disabled: true,
    // },
    {
      name: '服务供方',
      prop: 'serviceProviderCode',
      type: 'select',
      options: ctx.serviceProviderList || [],
      label: 'supplierName',
      value: 'supplierCode',
      disabled: ctx.disabledFlag,
      changeMethod: 'handleAgencyChange',
    },
    {
      name: '订舱要求',
      prop: 'bookingRequire',
      type: 'input',
      disabled: ctx.disabledFlag,
    },
    {
      name: '启运站省份',
      prop: 'departureProvinceCode',
      type: 'select',
      options: ctx.dictListMap?.province || [],
      disabled: ctx.disabledFlag,
    },
    {
      name: '启运站',
      prop: 'departurePlaceName',
      // type: 'select',
      type: 'input',
      // options: ctx.stationList,
      disabled: ctx.disabledFlag,
      // label: 'stationName',
      // value: 'stationCode',
      // changeMethod: 'handleAgencyChange',
    },
    {
      name: '到达站省份',
      prop: 'destinationProvinceCode',
      type: 'select',
      options: ctx.dictListMap?.province || [],
      disabled: ctx.disabledFlag,
    },
    {
      name: '到达站',
      prop: 'destinationName',
      type: 'input',
      // type: 'select',
      // options: ctx.stationList,
      disabled: ctx.disabledFlag,
      // label: 'stationName',
      // value: 'stationCode',
      // changeMethod: 'handleAgencyChange',
    },
    {
      name: '结算重量',
      prop: 'roughWeight',
      type: 'inputNumber',
      disabled: ctx.disabledFlag,
    },
    {
      name: '结算单位',
      prop: 'roughWeightUnit',
      type: 'select',
      options: ctx.weightUnitList || [],
      disabled: ctx.disabledFlag,
    },
  ];
};

export const agencyDetailForm = [
  {
    name: '指令单编号',
    prop: 'instructCode',
    type: 'input',
  },
  // {
  //   name: '采购组织',
  //   prop: 'purchaseOrgName',
  //   type: 'input',
  // },
  {
    name: '服务供方',
    prop: 'serviceProviderName',
    type: 'input',
  },
  {
    name: '指令单状态',
    prop: 'instructStatus',
    type: 'input',
  },
  {
    name: '服务下发时间',
    prop: 'instructIssueDate',
    type: 'input',
  },
  {
    name: '最近更新时间',
    prop: 'instructUpdateDate',
    type: 'input',
  },
  {
    name: '舱位类型',
    prop: 'classType',
    type: 'input',
  },
  {
    name: '订舱要求',
    prop: 'bookingRequire',
    type: 'input',
  },
  {
    name: '启运站省份',
    prop: 'departureProvinceName',
    type: 'input',
  },
  {
    name: '启运站',
    prop: 'departurePlaceName',
    type: 'input',
  },
  {
    name: '到达站省份',
    prop: 'destinationProvince',
    type: 'input',
  },
  {
    name: '到达站',
    prop: 'destinationName',
    type: 'input',
  },
  {
    name: '结算重量',
    prop: 'roughWeight',
    type: 'input',
  },
  {
    name: '结算单位',
    prop: 'roughWeightUnit',
    type: 'input',
  },
  {
    name: '完结时间',
    prop: 'businessComplatedDate',
    type: 'input',
  },
];

// 铁路运输代理服务表头
export const agencyColumn = [
  {
    type: 'checkbox',
    visible: true,
    width: '50',
    fixed: 'left',
  },
  {
    type: 'index',
    visible: true,
    width: '60',
    fixed: 'left',
    title: '序号',
  },
  {
    field: 'containerType',
    title: '箱型',
    visible: true,
  },
  {
    field: 'rentDate',
    title: '租箱日期',
    visible: true,
  },
  {
    field: 'tranStartDate',
    title: '开班日期',
    visible: true,
  },
  {
    field: 'productName',
    title: '货物品名',
    visible: true,
  },
  {
    field: 'remarks',
    title: '备注',
    visible: true,
  },
];

// 铁路运输代理服详情务表头
export const agencyDetailColumn = [
  {
    type: 'checkbox',
    visible: true,
    width: '50',
    fixed: 'left',
  },
  {
    type: 'index',
    visible: true,
    width: '60',
    fixed: 'left',
    title: '序号',
  },
  {
    field: 'containerType',
    title: '箱型',
    visible: true,
  },
  {
    field: 'containerNo',
    title: '集装箱号',
    visible: true,
  },
  {
    field: 'suspendNo',
    title: '封号',
    visible: true,
  },
  {
    field: 'productName',
    title: '货物品名',
    visible: true,
  },
  {
    field: 'rentProvider',
    title: '租箱供方',
    visible: true,
  },
  {
    field: 'rentDate',
    title: '租箱日期',
    visible: true,
  },
  {
    field: 'bookDate',
    title: '订舱日期',
    visible: true,
  },
  {
    field: 'trainNo',
    title: '班列号',
    visible: true,
  },
  {
    field: 'tranStartDate',
    title: '计划开班日期',
    visible: true,
  },
  {
    field: 'planTranStartDate',
    title: '实际开班日期',
    visible: true,
  },
  {
    field: 'railwayWaybillNo',
    title: '铁路运单号',
    visible: true,
  },
  {
    field: 'stationUnloadDate',
    title: '站点卸车日期',
    visible: true,
  },
  {
    field: 'remarks',
    title: '备注',
    visible: true,
  },
];

// 新增弹框铁路运输代理服务表格
export const addAgencyForm = (ctx) => {
  return [
    {
      name: '箱型',
      prop: 'containerType',
      type: 'input',
      disabled: true,
    },
    {
      name: '租箱日期',
      prop: 'rentDate',
      type: 'date',
    },
    {
      name: '开班日期',
      prop: 'tranStartDate',
      type: 'date',
    },
    // {
    //   name: '货物名称',
    //   prop: 'productName',
    //   type: 'input',
    // },
    {
      name: '货物名称',
      prop: 'productName',
      type: 'select',
      options: ctx.productParentList,
      filterable: true,
      value: 'label',
      label: 'label',
      // type: 'searchTableSpec',
      // searchType: 'goodsIntermodalityContractParent',
      // isMultiple: true,
      // extraData: {
      //   parentProductStatus: 'ZT03',
      //   adminFlag: ctx.userInfo.adminFlag,
      //   selectCompanyCode: ctx.userInfo.companyCode,
      //   contractCode: ctx.contractCode,
      // },
      // currentValue: ctx.agencyServiceData.productName,
      changeMethod: ctx.changeProductHandler,
    },
    // {
    //   name: '货物名称',
    //   prop: 'productName',
    //   type: 'searchTableSpec',
    //   searchType: 'product',
    //   isMultiple: true,
    //   extraData: {
    //     parentProductStatus: 'ZT03',
    //     adminFlag: ctx.userInfo.adminFlag,
    //   },
    //   currentValue: ctx.agencyServiceData.productName,
    //   // checkRowKeys: [ctx.agencyServiceData.productCode],
    //   // disabled: ctx.formItemDisable,
    //   changeMethod: ctx.changeProductHandler,
    // },
    {
      name: '备注',
      prop: 'remarks',
      type: 'input',
    },
  ];
};

// 异常维护表头
export const abnormalColumn = [
  {
    type: 'checkbox',
    visible: true,
    width: '50',
    fixed: 'left',
  },
  {
    type: 'index',
    visible: true,
    width: '60',
    fixed: 'left',
    title: '序号',
  },
  {
    field: 'exceptionCode',
    title: '异常编号',
    visible: true,
  },
  {
    field: 'exceptionType',
    title: '异常类型',
    visible: true,
  },
  {
    field: 'exceptionDescription',
    title: '异常描述',
    visible: true,
  },
  {
    field: 'exceptionReason',
    title: '异常原因',
    visible: true,
  },
  {
    field: 'hasExceptionExpense',
    title: '是否有异常费用',
    visible: true,
  },
  {
    field: 'createByName',
    title: '创建人',
    visible: true,
  },
  {
    field: 'gmtCreate',
    title: '创建时间',
    visible: true,
  },
  {
    field: 'remarks',
    title: '备注',
    visible: true,
  },
];
// 异常类型
export const exceptionTypeList = [
  {
    label: '运输异常',
    value: '0',
  },
  {
    label: '订单异常',
    value: '1',
  },
];

// 异常原因
export const exceptionReasonList = [
  {
    label: '供方导致',
    value: '0',
  },
  {
    label: '客户导致',
    value: '1',
  },
];
export const hasExceptionExpenseList = [
  {
    label: '无',
    value: '0',
  },
  {
    label: '有',
    value: '1',
  },
];

// 异常维护表单
export const abnormalForm = [
  {
    name: '异常编码',
    prop: 'exceptionCode',
    type: 'input',
    disabled: true,
  },
  {
    name: '异常描述',
    prop: 'exceptionDescription',
    type: 'input',
  },
  {
    name: '异常类型',
    prop: 'exceptionType',
    type: 'select',
    options: exceptionTypeList,
  },
  {
    name: '异常原因',
    prop: 'exceptionReason',
    type: 'select',
    options: exceptionReasonList,
  },
  {
    name: '是否有异常费用',
    prop: 'hasExceptionExpense',
    type: 'select',
    options: hasExceptionExpenseList,
  },
  {
    name: '备注',
    prop: 'remarks',
    type: 'input',
  },
];

export const abnormalFormRules = {
  exceptionDescription: [{ required: true, message: '异常描述必填', trigger: 'change' }],
  exceptionType: [{ required: true, message: '异常类型必选', trigger: 'change' }],
  exceptionReason: [{ required: true, message: '异常原因必选', trigger: 'change' }],
};

//  草稿 删除  后面状态不能
export const instructStatusList = [
  {
    label: '草稿',
    value: 'draft',
  },
  {
    label: '已作废',
    value: 'invalid',
  },
  {
    label: '已下发',
    value: 'issued',
  },
  {
    label: '已配载',
    value: 'allocated',
  },
  {
    label: '已派车',
    value: 'dispatch',
  },
  {
    label: '已到场',
    value: 'present',
  },
  {
    label: '已发货',
    value: 'delivered',
  },
  {
    label: '运输中',
    value: 'transit',
  },
  {
    label: '已到货',
    value: 'arrived',
  },
  {
    label: '已完成',
    value: 'completed',
  },
];

export const trackColumns = [
  {
    field: 'trackNo',
    title: '运单号',
    visible: true,
  },
  {
    field: 'actualTransportCarNo',
    title: '实际运输车牌号',
    visible: true,
  },
  {
    field: 'actualTransportContainerNo',
    title: '实际运输箱号',
    visible: true,
  },
  {
    field: 'driverName',
    title: '司机姓名',
    visible: true,
  },
  {
    field: 'driverPhone',
    title: '司机电话',
    visible: true,
  },
  {
    field: 'actualPickupDate',
    title: '实际提货日期',
    visible: true,
  },
  {
    field: 'actualPickupDate',
    title: '实际装货日期',
    visible: true,
  },
  {
    field: 'actualDeliveryDate',
    title: '实际送货日期',
    visible: true,
  },
  {
    field: 'actualSignDate',
    title: '实际签收日期',
    visible: true,
  },
  {
    field: 'actualReceiptDate',
    title: '实际回单时间',
    visible: true,
  },
  {
    field: 'operate',
    title: '操作',
    visible: true,
    // fixed: 'right',
    width: 200,
  },
];

export const generalColumns = [
  {
    field: 'trackNo',
    title: '运单号',
    visible: true,
  },
  {
    field: 'actualTransportCarNo',
    title: '实际运输车牌号',
    visible: true,
  },
  {
    field: 'driverName',
    title: '司机姓名',
    visible: true,
  },
  {
    field: 'driverPhone',
    title: '司机电话',
    visible: true,
  },
  {
    field: 'actualPickupDate',
    title: '实际提货日期',
    visible: true,
  },
  {
    field: 'actualLoadeCompletedDate',
    title: '实际装货日期',
    visible: true,
  },
  {
    field: 'actualDeliveryDate',
    title: '实际送货日期',
    visible: true,
  },
  {
    field: 'actualSignDate',
    title: '实际签收日期',
    visible: true,
  },
  {
    field: 'actualReceiptDate',
    title: '实际回单时间',
    visible: true,
  },
  {
    field: 'operate',
    title: '操作',
    visible: true,
    // fixed: 'right',
    width: 200,
  },
];
